import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Editor } from "@tinymce/tinymce-react";
import {
  getNewsletterById,
  updateNewsletter,
} from "../../../project/services/NewsletterService";
import { useFormik } from "formik";
import Header from "../inc/Header";
import Navigation from "../inc/Navigation";
import { ToastContainer } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";

export default function UpdateNewsletter() {
  const [date, setDate] = useState("");
  const [titre, setTitre] = useState("");
  const [numero, setNumero] = useState("");
  const [cover, setCover] = useState(null);
  const [coverUrl, setCoverUrl] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [content, setContent] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();

  // Récupérer l'ID depuis l'URL (ex: /update/:id)
  useEffect(() => {
    if (id) {
      getNewsletterById(id).then((data) => {
        setTitre(data.titre || "");
        setNumero(data.numero || "");
        setDate(data.date_sortie ? data.date_sortie.slice(0, 10) : "");
        setContent(data.content || "");
        setCoverUrl(data.cover || null);
      });
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    try {
      const updatedNewsletter = {
        titre,
        numero: parseInt(numero, 10),
        date_sortie: date,
        content,
        cover: "", // sera remplacé côté backend si image
        isDeleted: 0,
      };
      // Si cover modifié, tu peux adapter le service pour gérer l'upload

      const response = await updateNewsletter(id, updatedNewsletter, cover);
      if (response && response.id_newsletter) {
        // Réinitialise le formulaire

        setMessage("Newsletter modifiée avec succès !");

        // Redirection avec state success
        navigate(process.env.REACT_APP_ADMIN_URL + "/list-Newsletter", {
          state: { success: true },
        });
      } else {
        setMessage("Erreur lors de l'enregistrement.");
      }
    } catch (err) {
      setMessage("Erreur lors de la modification.");
    }
    setLoading(false);
  };

  return (
    <>
      <Header />
      <Navigation />
      <ToastContainer />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Newsletter</h1>
        </div>
        <section className="section">
          <div className="row">
            <div className="card">
              <div className="card-body">
                <h2 className="card-title"> Modifier le Newsletter</h2>
                <form
                  className="formulaire"
                  onSubmit={handleSubmit}
                  onReset={() => {
                    setCover(null);
                    setPreviewUrl(null);
                  }}
                >
                  {/* Numéro */}
                  <div className="row mb-3">
                    <label
                      htmlFor="inputNumero"
                      className="col-sm-2 col-form-label"
                    >
                      Numéro
                    </label>
                    <div className="col-sm-10">
                      <input
                        type="number"
                        className="form-control"
                        id="numero"
                        value={numero}
                        onChange={(e) => setNumero(e.target.value)}
                        required
                        min={1}
                      />
                    </div>
                  </div>
                  {/* Date */}
                  <div className="row mb-3">
                    <label
                      htmlFor="inputDate"
                      className="col-sm-2 col-form-label"
                    >
                      Date
                    </label>
                    <div className="col-sm-10">
                      <input
                        type="date"
                        className="form-control"
                        id="date"
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  {/* Titre */}
                  <div className="row mb-3">
                    <label
                      htmlFor="inputText"
                      className="col-sm-2 col-form-label"
                    >
                      Titre
                    </label>
                    <div className="col-sm-10">
                      <input
                        type="text"
                        className="form-control"
                        id="titre"
                        value={titre}
                        onChange={(e) => setTitre(e.target.value)}
                      />
                    </div>
                  </div>
                  {/* Cover */}
                  <div className="row mb-3">
                    <label
                      htmlFor="inputFile"
                      className="col-sm-2 col-form-label"
                    >
                      Cover
                    </label>
                    <div className="col-sm-10">
                      <input
                        type="file"
                        className="form-control"
                        id="cover"
                        name="cover"
                        accept="image/*"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          setCover(file);
                          setPreviewUrl(
                            file ? URL.createObjectURL(file) : null,
                          );
                        }}
                      />
                      {coverUrl && (
                        <div className="mt-2">
                          <small className="text-muted">
                            Fichier actuel :{" "}
                            <strong>{coverUrl.split("/").pop()}</strong>
                          </small>
                          {!previewUrl && (
                            <div className="mt-1">
                              <img
                                src={coverUrl}
                                alt="Aperçu cover"
                                style={{
                                  width: "120px",
                                  height: "auto",
                                  borderRadius: "4px",
                                }}
                              />
                            </div>
                          )}
                        </div>
                      )}
                      {previewUrl && (
                        <div className="mt-2">
                          <small style={{ color: "#198754" }}>
                            Nouveau fichier sélectionné
                          </small>
                          <div className="mt-1">
                            <img
                              src={previewUrl}
                              alt="Aperçu nouveau"
                              style={{
                                width: "120px",
                                height: "auto",
                                borderRadius: "4px",
                              }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {/* Content */}
                  <div className="row mb-3">
                    <label
                      htmlFor="content"
                      className="col-sm-2 col-form-label"
                    >
                      Content
                    </label>
                    <div className="col-sm-10">
                      <div id="ckeditor-wrapper">
                        <Editor
                          apiKey="kh06mteonmrasd17vedrkdxsb1clqjuvm7qh7up3sh8o7dni"
                          value={content}
                          onEditorChange={setContent}
                          init={{
                            height: 500,
                            menubar:
                              "favs view file edit insert format tools table",
                            plugins: [
                              "fullscreen",
                              "advlist",
                              "autolink",
                              "lists",
                              "link",
                              "image",
                              "charmap",
                              "print",
                              "preview",
                              "anchor",
                              "searchreplace",
                              "visualblocks",
                              "code",
                              "insertdatetime",
                              "media",
                              "table",
                              "paste",
                              "wordcount",
                              "template",
                            ],
                            style_formats: [
                              {
                                title: "Ombre gris",
                                block: "div",
                                classes: "shadow-gray",
                                wrapper: true,
                              },
                              {
                                title: "paragraph",
                                block: "div",
                                classes: "clear-paragraph",
                                wrapper: true,
                              },
                            ],
                            templates: [
                              {
                                title: "Deux colonnes (flex)",
                                description:
                                  "Insérer une structure à deux colonnes",
                                content:
                                  '<div className="two-columns"><div><p>Colonne 1...</p></div><div><p>Colonne 2...</p></div></div>',
                              },
                            ],
                            toolbar:
                              "template | fullscreen undo redo | formatselect | " +
                              "bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat",
                            content_style: `
                                                            body{font-family:AdriaGrotesk-Thin;}
                                                            .two-columns{display:flex; gap:50px;}
                                                            .two-columns > div{flex:1;}
                                                            .shadow-gray{  background-color: #f7f7f7;
                                                                padding: 20px 30px;
                                                                border-radius: 34px;
                                                                box-shadow: 0 4px 10px rgba(0,0,0,0.1);
                                                                max-width: 1240px;   }
                                                            `,
                            font_family_formats:
                              "Roboto Medium=Roboto-Medium;Roboto Light=Roboto-Light;Roboto Thin=Roboto-Thin;Roboto Black=Roboto-Black;Roboto Regular=Roboto-Regular;Roboto Bold=Roboto-Bold;",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-sm-10 offset-sm-2">
                      <button
                        type="submit"
                        className="btn-axian-cramoisie"
                        disabled={loading}
                      >
                        {loading ? "Modification..." : "Modifier"}
                      </button>
                    </div>
                  </div>
                  {message && (
                    <div className="row mb-3">
                      <div className="col-sm-10 offset-sm-2">
                        <div
                          className={
                            message.includes("succès")
                              ? "alert alert-success"
                              : "alert alert-danger"
                          }
                        >
                          {message}
                        </div>
                      </div>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
